import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase";
import UserSmallTile from "../components/UserSmallTile";
import { UserType } from "../utils/types";
import { fetchUser } from "./ProfileUtil";
import { useIntl } from "react-intl";
import Spinner from "../components/Spinner";

function MyConnections() {
  const auth = getAuth();
  const intl = useIntl();
  const [loggedinUser, setLoggedinUser] = useState<UserType | null>(null);
  const [users, setUsers] = useState<UserType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.currentUser?.uid) {
      fetchUser(auth.currentUser?.uid, setLoggedinUser);
    }
  }, [auth.currentUser?.uid]);

  useEffect(() => {
    if (!loggedinUser) {
      return;
    }
    if (!loggedinUser.connections || loggedinUser.connections.length === 0) {
      setLoading(false);
      return;
    }

    const fetchUsers = async () => {
      const userIds = loggedinUser.connections;
      const usersList = (await Promise.all(
        userIds.map(async (id) => {
          const docRef = doc(db, "users", id);
          const docSnap = await getDoc(docRef);
          return docSnap.exists()
            ? { id: docSnap.id, ...docSnap.data() }
            : null;
        })
      ).then((docs) => docs.filter((doc) => doc !== null))) as UserType[];

      setUsers(usersList);
      setLoading(false);
    };

    fetchUsers();
  }, [loggedinUser]);

  const userConnections =
    users.length > 0 ? (
      users.map((user) => (
        <div className="home-grid-user">
          <UserSmallTile
            key={user.id}
            user={user}
            loggedinUserConnections={
              loggedinUser?.connections ? loggedinUser?.connections : []
            }
          />
        </div>
      ))
    ) : (
      <div>
        <div className="home-grid-user-empty-connections-list">
          <p>{intl.formatMessage({ id: "myconnections.emptyListMsg1" })}</p>
        </div>
        <div className="home-grid-user-empty-connections-list">
          <p>{intl.formatMessage({ id: "myconnections.emptyListMsg2" })}</p>
        </div>
      </div>
    );

  if (loading) return <Spinner />;

  return (
    <div className="home-page">
      <section className="myconnections-container">
        <h1 className="myconnections-heading">
          {intl.formatMessage({ id: "header.myConnections" })}
        </h1>
        <div className="home-grid-users">{userConnections}</div>
      </section>
    </div>
  );
}

export default MyConnections;
